import { fromJS, Map } from 'immutable';
import types from '../constants/reportConstants';

const INITIAL_STATE = {};

const initialImmutableState = fromJS(INITIAL_STATE);

const reportReducer = (state = initialImmutableState, action = {}) => {
  switch (action.type) {
    case types.SET_USER_COUNT:
      return state.withMutations((mutableState) => {
        mutableState.set('userCount', fromJS(action.payload));
        mutableState.set('userCountError', null);
      });
    case types.SET_ADMIN_APP_REPORT:
      return state.withMutations((mutableState) => {
        mutableState.set('adminAppReport', fromJS(action.payload));
        mutableState.set('appReportError', null);
      });
    case types.SET_BUILDING_APP_REPORT:
      return state.withMutations((mutableState) => {
        mutableState.set('buildingAppReport', fromJS(action.payload));
      });
    case types.SET_LANDLORD_APP_REPORT:
      return state.withMutations((mutableState) => {
        mutableState.set('landlordAppReport', fromJS(action.payload));
      });
    case types.SET_FLAGGED_CANCEL_REPORT:
      return state.withMutations((mutableState) => {
        mutableState.set('flaggedCancelCountReport', fromJS(action.payload));
      });
    case types.SET_BUILDING_COUNT:
      return state.withMutations((mutableState) => {
        mutableState.set('buildingCount', fromJS(action.payload));
        mutableState.set('buildingCountError', null);
      });
    case types.SET_LANDLORD_COUNT:
      return state.withMutations((mutableState) => {
        mutableState.set('landlordCount', fromJS(action.payload));
      });
    case types.SET_USER_COUNT_ERROR:
      return state.withMutations((mutableState) => {
        mutableState.set('userCountError', action.payload || 'Unable to load user counts.');
      });
    case types.SET_BUILDING_COUNT_ERROR:
      return state.withMutations((mutableState) => {
        mutableState.set('buildingCountError', action.payload || 'Unable to load property counts.');
      });
    case types.SET_APP_REPORT_ERROR:
      return state.withMutations((mutableState) => {
        mutableState.set('appReportError', action.payload || 'Unable to load dashboard charts.');
      });
    default:
      return state;
  }
};

export default reportReducer;
